import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "rowTemplate"]
  static values = { minDate: String }

  connect() {
    if (this.rowsTarget.children.length === 0) this.addRow()
    this.rowsTarget.querySelectorAll("tr").forEach((row) => this.syncRow(row))
  }

  addRow() {
    const fragment = this.rowTemplateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(fragment)
    this.syncRow(this.rowsTarget.lastElementChild)
  }

  removeRow(event) {
    const row = event.target.closest("tr")

    if (this.rowsTarget.children.length === 1) {
      row.querySelectorAll("input, select").forEach((field) => {
        field.value = ""
        field.disabled = false
      })
      row.querySelector("[data-schedule-note]").textContent = ""
      return
    }

    row.remove()
  }

  employeeChanged(event) {
    this.syncEmployee(event.target.closest("tr"))
  }

  typeChanged(event) {
    this.syncType(event.target.closest("tr"))
  }

  dateChanged(event) {
    const row = event.target.closest("tr")
    this.syncEndDate(row)
    this.validateRow(row)
  }

  validate(event) {
    let firstInvalidField = null

    this.rowsTarget.querySelectorAll("tr").forEach((row) => {
      const invalidField = this.validateRow(row)
      if (!firstInvalidField && invalidField) firstInvalidField = invalidField
    })

    if (firstInvalidField) {
      event.preventDefault()
      firstInvalidField.reportValidity()
    }
  }

  syncRow(row) {
    this.syncEmployee(row)
    this.syncType(row)
    this.syncMinDates(row)
    this.syncEndDate(row)
  }

  syncEmployee(row) {
    const employeeSelect = row.querySelector("[data-employee-select]")
    const selected = employeeSelect.selectedOptions[0]
    const note = row.querySelector("[data-schedule-note]")

    note.textContent = selected?.dataset.schedule || ""
  }

  syncType(row) {
    const typeSelect = row.querySelector("[data-type-select]")
    const selected = typeSelect.selectedOptions[0]
    const requiresSchedule = selected?.dataset.requiresSchedule !== "false"
    const timeFields = row.querySelectorAll("[data-time-field]")

    timeFields.forEach((field) => {
      field.disabled = !requiresSchedule
      field.required = requiresSchedule
      if (!requiresSchedule) field.value = ""
    })

    const endDateField = row.querySelector("[data-end-date-field]")
    if (endDateField) {
      endDateField.disabled = !requiresSchedule
      endDateField.required = requiresSchedule
      if (!requiresSchedule) endDateField.value = row.querySelector("[data-start-date-field]")?.value || ""
    }
  }

  syncMinDates(row) {
    row.querySelectorAll("[data-start-date-field], [data-end-date-field]").forEach((field) => {
      field.min = this.minDateValue
    })
  }

  syncEndDate(row) {
    const startDateField = row.querySelector("[data-start-date-field]")
    const endDateField = row.querySelector("[data-end-date-field]")
    if (!startDateField || !endDateField) return

    endDateField.min = startDateField.value || this.minDateValue
    if (startDateField.value && (!endDateField.value || endDateField.value < startDateField.value)) {
      endDateField.value = startDateField.value
    }
  }

  validateRow(row) {
    const typeSelect = row.querySelector("[data-type-select]")
    const requiresSchedule = typeSelect.selectedOptions[0]?.dataset.requiresSchedule !== "false"
    if (!requiresSchedule) return null

    const startDateField = row.querySelector("[data-start-date-field]")
    const endDateField = row.querySelector("[data-end-date-field]")
    const startTimeField = row.querySelector("[data-start-time-field]")
    const endTimeField = row.querySelector("[data-end-time-field]")

    ;[endDateField, endTimeField].forEach((field) => field?.setCustomValidity(""))

    if (!startDateField?.value || !endDateField?.value || !startTimeField?.value || !endTimeField?.value) {
      return [startDateField, startTimeField, endDateField, endTimeField].find((field) => field && !field.value)
    }

    const arrival = `${startDateField.value}T${startTimeField.value}`
    const departure = `${endDateField.value}T${endTimeField.value}`

    if (departure <= arrival) {
      endTimeField.setCustomValidity("Η αποχώρηση πρέπει να είναι μετά την προσέλευση.")
      return endTimeField
    }

    return null
  }
}
